// @utilities
const apiURLBuilder = require('core/apiURLBuilder');
const { APIGet } = require('utilities/APIRequestHelper');

// @constants
const actionTypes = require('constants/actionTypes');

const requestContractValuesFetching = contractId => ({
    type: actionTypes.BROKER_CONTRACT_VALUES_REQUEST,
    payload: {
        contractId
    }
});

const requestContractValuesFailure = (contractId) => ({
    type: actionTypes.BROKER_CONTRACT_VALUES_FAILURE,
    payload: {
        contractId
    }
});

const requestContractValuesSuccess = (data, contractId) => ({
    type: actionTypes.BROKER_CONTRACT_VALUES_SUCCESS,
    payload: {
        data,
        contractId
    }
});

const getAllContractValuesSuccess = (response, contractId) => ({
    type: actionTypes.BROKER_CONTRACT_ALL_VALUES_SUCCESS,
    payload: {
        response,
        contractId
    }
});

const getAllContractValuesFailure = (contractId) => {
    const responseWithNoMovements = {};
    return getAllContractValuesSuccess(responseWithNoMovements, contractId);
};

const getAllContractValues = (immContract) => (dispatch) => {
    const url = apiURLBuilder.getURL('brokerContratosMovimientos');

    const productNumber = immContract.get('productNumber');
    const contractNumber = immContract.get('walletNumber');
    const requestData = {
        producto: productNumber,
        numeroContrato: contractNumber,
        paginate: false
    };

    dispatch(requestContractValuesFetching(contractNumber));

    return APIGet(dispatch, url, { query: requestData }).then(
        (response) => dispatch(getAllContractValuesSuccess(response, contractNumber)),
        () => dispatch(getAllContractValuesFailure(contractNumber))
    );
};

const getContractValues = immContract => (dispatch, getState) => {
    const immStocksContracts = getState().brokerStocksContract;
    const walletNumber = immContract.get('walletNumber');
    const immStockContract = immStocksContracts.find(
        value => {
            return value.get('walletNumber') === walletNumber;
        }
    );

    dispatch(requestContractValuesFetching(walletNumber)); //just for backward compatibility

    if (immStockContract) {
        dispatch(requestContractValuesSuccess(immStockContract, walletNumber));
    } else {
        dispatch(requestContractValuesFailure(walletNumber));
    }
}

module.exports = {
    getContractValues,
    getAllContractValues
};
